import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import InputGroup from 'react-bootstrap/InputGroup';
import { settingsFunctions } from '../../../../functions/settings';
import ButtonSelector from './ButtonSelector';
import ButtonTypeReturn from './ButtonTypeReturn';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { useAuth } from '../../../../utils/Auth';
import './AddButton.css';

function AddButton(props) {
    const { buttons, setButtonState, setShowForm, accountType, uid, profile_theme } = props;
    const { updateVcardObject, buttonsActiveState, getButtonLink } = settingsFunctions;
    const { getUpdatedUserVcard } = useAuth();

    const [ icon, setIcon ] = useState();
    const [ buttonType, setButtonType ] = useState('');
    const [ buttonHasChanges, setButtonHasChanges ] = useState(false);
    const [ button, setButton ] = useState("");
    const [ label, setLabel ] = useState("");
    const [ showSpinner, setShowSpinner ] = useState(false);

    useEffect(() => {
        if (buttonType) {
            setIcon(buttonType.icon);
        };
    },[buttonType]);

    const resetForm = () => {
        setButton("");
        setLabel("");
        setButtonHasChanges(false);
    };

    const saveNewButton = async () => {
        const newButton = {
            active: true,
            added: Date.now(),
            data: buttonType.ref === 'phone' ? formatPhoneNumberIntl(button) : getButtonLink(buttonType.ref, button.replace(/\/$/,'')),
            icon: icon,
            label: label?.length > 0 ? label : "",
            ref: buttonType.ref
        };
            
        const newButtonsArr = buttons ? [newButton, ...buttons] : [newButton];
        const update = { buttons: accountType === 'basic' ? buttonsActiveState(newButtonsArr, newButtonsArr) : newButtonsArr };

        setButtonState(update.buttons);
        setShowSpinner(true);
        await updateVcardObject(update, uid).then(async () => {
            await getUpdatedUserVcard().then(() => {
                setShowSpinner(false);
                setButtonHasChanges(false);
                setShowForm('');
            });
        });
    };

    return(
        <div className='add-button-container'>
            <Card.Header className='add-button-header'>
                <div className='add-button-back-btn' onClick={e => {buttonType ? setButtonType('') :  setShowForm("")}}>
                    <i className='fas fa-arrow-left'></i>
                    Back
                </div>
                Add New Button
                <div className='add-button-reset-btn' onClick={e => {e.preventDefault(); resetForm()}}>
                    Reset
                </div>
            </Card.Header>
            <div className='add-button-container-inner'>
                {!buttonType ?
                <div className='d-flex justify-content-center'>
                    <ButtonSelector setButtonType={setButtonType} />
                </div>
                :
                    <ButtonTypeReturn button={button} profile_theme={profile_theme} setButton={setButton} label={label} setLabel={setLabel} buttonType={buttonType} setButtonHasChanges={setButtonHasChanges} icon={icon} setIcon={setIcon} />}
                {buttonType && <InputGroup className='button-selector-input-group'>
                    <button 
                        onClick={saveNewButton} 
                        className='button-selector-btn' 
                        disabled={!buttonHasChanges || showSpinner}>
                        {showSpinner ? <i className="fa-thin fa-spinner fa-spin-pulse"></i> : 'Accept'}
                    </button>
                </InputGroup>}
            </div>
        </div>
    );
};

export default AddButton;